import { LookupItem } from "./lookup-item.model";

/**
 * Base class for user gear.
 * The subclasses are PotGear, LonglineGear, PelagicGear
 * This class also used for HMS gear, which is far simpler and requires no subclass implementations
 */
export class Gear {

    //Unique identifier for this single gear
    gearID: string = '';

    //Links to a fishing event if this gear has been added to it
    fishingEventID: string = '';

    identifier: string = '';

    fishery: string = '';

    //This type field is either Pot, Longline, Pelagic, or an HMS Type (Harpoon, Rod and Reel, Troll line, Gillnet drift, Pole, DSBG)
    type: string = '';

    //Pot, Longline, Pelagic, and HMS DSBG each have a subtype -- corresponds to gear id and type 
    gearSubtype: LookupItem = new LookupItem('');


    //This is effectively only called to display HMS gear
    toString() {
      console.log(this.type)
        if (this.identifier == '')
            return '';
      return this.identifier + ' -- ' + this.type + ((this.type == 'Deep Set Buoy Gear') ? " - " + this.gearSubtype.name : '');
    }

    isEqual(cmp: any) {
        return false;
    }

    static transformAnonymous(anon: any) {
        let g = new Gear();
        g.gearID = anon.gearID;
        g.fishingEventID = anon.fishingEventID;
        g.identifier = anon.identifier;
        g.fishery = anon.fishery;
        g.type = anon.type;
        g.gearSubtype = LookupItem.transformAnonymous(anon.gearSubtype);
        return g;
    }
}
